import React from "react";
import { Link } from "react-router-dom";
import { useProductsContext } from "../context/Context";

const NaxtPage = ({ text, link }) => {
  const { CursorBig, CursorSmall } = useProductsContext();

  return (
    <>
      <div className="naxt-page">
        <Link
          to={link}
          className="naxt-page__btn"
          onMouseOver={CursorBig}
          onMouseOut={CursorSmall}
          onClick={CursorSmall}
        >
          <marquee direction="left" scrollamount="12">
            {text}
          </marquee>
        </Link>
      </div>
    </>
  );
};

export default NaxtPage;
